import { ErrorHandler, Injectable, Injector} from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs';
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) { }
  handleError(error) {
    const router = this.injector.get(Router);
     if(error !== "TypeError: Cannot read property 'getAttribute' of undefined" && window.location.href.indexOf("/checkout/payment")!==-1)
       router.navigateByUrl("/checkout")
     // IMPORTANT: Rethrow the error otherwise it gets swallowed
     console.error( error);
    // console.error("ERROR :"+error);
  }
  
}